<template>
    <v-dialog v-model="dialog" fullscreen scrollable>
        <v-card tile color="#333333" v-if="isReady" v-resize="onResize">
            <v-card-title class="pa-0 d-flex justify-center" style="background: #3b3b3b; min-height: 48px; border-bottom-color: white">
                <v-row no-gutters class="standard-row d-flex justify-space-between" align="center">
                    <v-col cols="11" :sm="windowSize.x <= 800? (typeFile === 'image')? '9' : '11' : '4'" md="4" lg="4" align-self="center" :class="windowSize.x <= 800 && typeFile === 'pdf'? 'd-flex justify-center' : 'd-flex justify-start'">
                        <span style="color: white; font-size: 16px;" class="font-theme pl-3 text-truncate">{{ fileName }}</span>
                    </v-col>
                    <v-col v-if="typeFile !== 'image'" cols="6" :sm="windowSize.x <= 800? '6' : ''" md="" lg="" align-self="center" :class="windowSize.x <= 800? 'd-flex justify-start' : 'd-flex justify-center'">
                        <v-btn icon @click="changePage('prev')">
                            <v-icon size="20" color="white">mdi-arrow-left</v-icon>
                        </v-btn> 
                        <span class="white--text mx-2" style="font-size: 16px;">{{page}} / {{ numPages }}</span>
                        <v-btn icon @click="changePage('next')">
                            <v-icon size="20" color="white">mdi-arrow-right</v-icon>
                        </v-btn>
                    </v-col>
                    <v-spacer v-if="typeFile === 'image'"></v-spacer>
                    <v-col v-if="typeFile !== 'image'" cols="6" :sm="windowSize.x <= 800? '6' : '4'" md="4" lg="4" align-self="center" class="pr-2 d-flex justify-end">
                        <v-btn icon @click="zoomFunction('out')">
                            <v-icon size="24" color="white">
                                mdi-magnify-minus-outline
                            </v-icon> 
                        </v-btn>
                        <v-btn icon @click="zoomFunction('in')">
                            <v-icon size="24" color="white">
                                mdi-magnify-plus-outline
                            </v-icon>
                        </v-btn>
                        <v-btn icon @click="dialog = false">
                            <v-icon size="24" color="white">
                                mdi-close
                            </v-icon> 
                        </v-btn>
                    </v-col>
                    <v-col v-else cols="" sm="3" class="pr-2 d-flex" :class="windowSize.x < 600? 'justify-space-between' : 'justify-end'">
                        <span>
                            <v-btn icon @click="zoomFunction('out')">
                                <v-icon size="24" color="white">
                                    mdi-magnify-minus-outline
                                </v-icon> 
                            </v-btn>
                            <v-btn icon @click="zoomFunction('in')">
                                <v-icon size="24" color="white">
                                    mdi-magnify-plus-outline
                                </v-icon>
                            </v-btn>
                        </span>
                        <v-btn icon @click="dialog = false">
                            <v-icon size="24" color="white">
                                mdi-close
                            </v-icon> 
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-row v-if="showPDF" no-gutters class="standard-row" justify="center">
                    <v-col cols="auto" sm="auto" md="auto" lg="auto" align-self="center" class="pa-0">
                        <pdf
                            v-if="typeFile === 'pdf'"
                            :page="page || 1"
                            :src="myFile"
                            :annotation="true"
                            :resize="true"
                            @error="errorFiles"
                            @numpages="setTotalPage"
                            style="display: inline; transform-origin: center top; width: 100%;"
                            :style="`zoom: ${scaleCanvas || 1};`"
                        >
                            <template slot="loading">
                                <span>Loading...</span>
                            </template>
                        </pdf>
                        <v-img
                            v-else
                            :src="myFile"
                            contain
                            class="mt-4"
                            :style="`zoom: ${scaleCanvas || 1}; transform-origin: center top; color: #333333;`" 
                        />
                    </v-col>
                </v-row>
                <v-row v-else no-gutters>
                    <v-overlay absolute>
                        <v-progress-circular indeterminate size="64" color="#F4F4F4"></v-progress-circular>
                    </v-overlay>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import pdf from "pdfvuer"
import { EventBus } from '../EventBus'
    export default {
        components: {
            pdf
        },
        data: () => ({
            page: 1,
            numPages: null,
            myFile: null,
            dialog: false,
            showPDF: true,
            isReady: null,
            fileName: null,
            typeFile: null,
            scaleCanvas: 1,
            windowSize: { x: 0 },
            canvasWidthSize: null,
            setTimeOutResize: null
        }),
        mounted() {
            this.onResize()
            EventBus.$on('openPDFModal', this.openDialog)
            window.addEventListener('resize', this.resizeWindowBrowser)
        },
        beforeDestroy() {
            EventBus.$off('openPDFModal')
            window.removeEventListener('resize', this.resizeWindowBrowser)
        },
        watch: {
            "dialog"(newValue) {
                if (!newValue) {
                    this.page     = 1
                    this.numPages = null
                    this.myFile   = null
                    this.isReady  = false
                    this.fileName = null
                    this.scaleCanvas = 1
                }
            },
            "scaleCanvas"() {
                this.canvasWidthSize = +$("div > #viewerContainer > .page > .canvasWrapper > canvas")?.css("width") || null
            }
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            openDialog(file, type) {
                if (type && typeof type === 'object' && type !== 'upload_file') {
                    this.fileName = type.name?.substring(0, type.name?.lastIndexOf('.'))
                    if (type.type === "pdf") {
                        this.typeFile = 'pdf'
                        this.convertBase64(file)
                    } else {
                        this.typeFile = 'image'
                        this.convertImageToBase64(file)
                    }
                } else {
                    this.fileName = file.name?.substring(0, file.name?.lastIndexOf('.'))
                    if (type === 'pdf') {
                        this.typeFile = 'pdf'
                        this.convertBase64(file)
                    } else {
                        this.typeFile = 'image'
                        this.convertImageToBase64(file)
                    }
                }
            },
            async convertBase64(file) {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = async() => {
                    try {
                        this.myFile = reader.result
                        this.myFile.then(pdf => {
                            this.numPages = pdf.numPages
                        })
                    } catch (error) {
                        this.myFile = pdf.createLoadingTask(reader.result)
                        this.myFile.then(pdf => {
                            this.numPages = pdf.numPages
                        })
                    } finally {
                        this.dialog  = true
                        this.isReady = true
                    }
                }
            },
            convertImageToBase64(file) {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onloadend = () => {
                    this.myFile = reader.result
                    this.dialog  = true
                    this.isReady = true
                }
            },
            setTotalPage(pages) {
                this.numPages = pages
            },
            changePage(action) {
                if (action === 'prev' && this.page > 1) {
                    this.page -= 1
                } else if (action === 'next' && this.page < this.numPages) {
                    this.page += 1
                }
            },
            zoomFunction(type) {
                if (type === 'in') {
                    this.scaleCanvas += 0.1
                } else if (type === 'out' && this.scaleCanvas >= 0.4) {
                    this.scaleCanvas -= 0.1
                }
            },
            errorFiles() {
                this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                this.dialog = false
            },
            resizeWindowBrowser() {
                this.showPDF = false
                clearTimeout(this.setTimeOutResize)
                    this.setTimeOutResize = setTimeout(() => {
                    this.showPDF = true
                }, 500)
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            }
        }
    }
</script>